import React, { Component } from 'react'; // eslint-disable-line

export default class Header extends Component {
  render() {
    const headerStyle = {
      width: '100%',
      textAlign: 'center',
    };
    const logoTextStyle = {
      textTransform: 'uppercase',
      fontSize: '3em',
      fontWeight: 500,
    };
    const subTitleStyle = {
      textTransform: 'uppercase',
      fontSize: '1em',
      fontWeight: 500,
      opacity: 0.4,
    };
    const titleSection = {
      padding: '72px 0 24px 0',
    };
    const tinyText = {
      margin: '0',
      padding: '24px 0',
      fontSize: '12px',
      opacity: 0.6,
    };

    return (
      <div style={headerStyle}>
        <div style={titleSection}>
          <h1 style={logoTextStyle}>Barry Chusid</h1>
          <h6 style={subTitleStyle}>Production Designer</h6>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/index.js